import { render, staticRenderFns } from "./DadosRebanhoRecria.vue?vue&type=template&id=fafc0b2c&scoped=true&"
import script from "./DadosRebanhoRecria.vue?vue&type=script&lang=js&"
export * from "./DadosRebanhoRecria.vue?vue&type=script&lang=js&"
import style0 from "./DadosRebanhoRecria.vue?vue&type=style&index=0&id=fafc0b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafc0b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VFlex,VForm,VLayout,VTextField})
